<template>
    <div class="col-md-12">
        <div class="col-md-12" v-for="respuesta in this.answers" style="padding: 15px; display: flex; flex-direction: row; width: 100%; border-bottom: solid grey 1px">
            <item-answers :respuesta="respuesta"></item-answers>
        </div>
        <div>
            <new-answers  :id_question="this.question_id"></new-answers>
        </div>
    </div>
</template>

<script>
    import itemAnswers from './itemAsnwers.vue'
    import newAnswers from './NewAnswers.vue'
    export default {
        name:'Answers',
        props:['answers', 'question_id'],
        data() {
            return {

            }
        },
        components: {
            itemAnswers,
            newAnswers
        },

        methods: {

        }    
    }
</script>
<style scoped>
    .main-questions{
        display: flex;
        flex-direction: column;
        background-color: #F0F0F0;
        border-radius: 10px;
        padding: 10px;
    }
    .top-questions{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        padding-top: 10px;
        padding-bottom: 10px
    }
</style>
